import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

interface IScTopGamesProps {
  showSlider?: boolean;
  customImages?: string[];
  fullMobWidth?: boolean;
  disableOnClick?: boolean;
}

export const ScTopGames = styled.div<IScTopGamesProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: ${({ customImages }) => (customImages ? '1140px' : '576px')};
  .title {
    ${typography.headline2};
    text-align: center;
    text-transform: uppercase;
    @media (${device.mobile}) {
      ${typography.headline2mobile};
    }
  }
  .image-wrapper {
    display: flex;
    gap: 16px;
    flex-direction: row;
    justify-content: center;
    width: ${({ showSlider }) => (showSlider ? 'inherit' : '576px')};
    @media (min-width: 360px) and (max-width: 372px) {
      gap: 8px;
    }
    @media (${device.mobile}) {
      width: 100%;
    }
  }

  .image {
    cursor: ${({ disableOnClick }) => (disableOnClick ? 'default' : 'pointer')};
    border-radius: 12px;
  }
  @media (${device.mobile}) {
    max-width: ${({ fullMobWidth }) => (fullMobWidth ? '100vw' : '90vw')};
  }
`;
